import { render, staticRenderFns } from "./ArchivesOfEachIssueJg.vue?vue&type=template&id=61ad0e79"
import script from "./ArchivesOfEachIssueJg.vue?vue&type=script&lang=js"
export * from "./ArchivesOfEachIssueJg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports